module.exports = __webpack_public_path__ + "static/aboutherofree-cbdb6ab34438580aa15c82d8398f5715.png";